import React, { useEffect } from 'react';
import {
  FlexGrid,
  getClassNameFactory,
  Heading,
  KalturaVideoPlayer,
  TextBoldness,
  Typography,
  VerticalSpacing,
  VerticalSpacingSizes,
} from '@dcl/ui';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { IPlaylistVideoPlayer } from '../../types';
import { kalturaSetupHandlerThunk } from '@dcl/ui/dist/fragments';
import { VideoPlayerIcon } from './icons/VideoPlayerIcon';
import { convertSecondsIntoMins } from '../../../../../../utils/convertSecondsIntoMins';
import { ARTICLE_FORMAT, ARTICLE_VIEWS } from '../../constants';
import './PlaylistVideoPlayer.css';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';

export const VideoPlayerPlaylist: React.FC<IPlaylistVideoPlayer> = (props) => {
  const getClassName = getClassNameFactory(VideoPlayerPlaylist.displayName);
  const {
    title,
    entryId,
    userKeyKs,
    duration = '0',
    views,
    format = 'Video',
  } = props;

  const headerTitle = title;
  const videoFormat = format;
  const kalturaVideoViews = views;
  const videoDuration = duration;
  useEffect(() => {
    kalturaSetupHandlerThunk();
  }, [entryId]);

  const kalturaPlayer = () => {
    return (
      <div
        className={getClassName({
          descendantName: 'player-kaltura',
        })}
      >
        <KalturaVideoPlayer entryId={entryId} ks={userKeyKs} />
      </div>
    );
  };

  return (
    <div className={getClassName()} role="tabpanel" aria-labelledby={entryId}>
      {kalturaPlayer()}

      <div
        className={getClassName({
          descendantName: 'description',
        })}
      >
        <Heading
          type={types.Small}
          boldType={boldTypes.medium}
          data-testid="test-title"
          className={getClassName({
            descendantName: 'title',
          })}
        >
          {headerTitle}
        </Heading>
        <VerticalSpacing size={VerticalSpacingSizes.S}>
          <FlexGrid>
            <FlexGrid.Row
              className={getClassName({ descendantName: 'eyeBrow' })}
            >
              <FlexGrid.Col xs={3} sm={3} md={3}>
                <Typography
                  tag={TypographyTags.SPAN}
                  boldness={TextBoldness.Regular}
                  className={getClassName({
                    descendantName: 'articleFormat',
                  })}
                >
                  {ARTICLE_FORMAT}
                </Typography>
              </FlexGrid.Col>

              <FlexGrid.Col xs={9} sm={9} md={9}>
                <div className={getClassName({ descendantName: 'Info' })}>
                  <div className={getClassName({ descendantName: 'Icon' })}>
                    <VideoPlayerIcon />
                  </div>
                  <Typography
                    tag={TypographyTags.SPAN}
                    boldness={TextBoldness.Light}
                    className={getClassName({
                      descendantName: 'articleFormat',
                    })}
                  >
                    {videoFormat}
                  </Typography>
                  <Typography
                    tag={TypographyTags.SPAN}
                    boldness={TextBoldness.Regular}
                  >
                    {convertSecondsIntoMins(videoDuration)}
                  </Typography>
                  <Typography
                    tag={TypographyTags.SPAN}
                    boldness={TextBoldness.Regular}
                  >
                    ·
                  </Typography>
                  <Typography
                    tag={TypographyTags.SPAN}
                    boldness={TextBoldness.Regular}
                  >
                    {kalturaVideoViews} {ARTICLE_VIEWS}
                  </Typography>
                </div>
              </FlexGrid.Col>
            </FlexGrid.Row>
          </FlexGrid>
        </VerticalSpacing>
      </div>
    </div>
  );
};

VideoPlayerPlaylist.displayName = 'PlaylistVideoPlayer';
